import React from "react";
import { Route } from "react-router-dom";
import AssignLeads from "../../AdminDashboard/TaxPreparation/AssignLeads/AssignLeads";
import All from "../../AdminDashboard/TaxPreparation/All/All";
import Messages from "../../AdminDashboard/TaxPreparation/Messages/Messages";
import NewFile from "../../AdminDashboard/TaxPreparation/NewFile/NewFile";
import DocsPending from "../../AdminDashboard/TaxPreparation/DocsPending/DocsPending";
import CallBack from "../../AdminDashboard/TaxPreparation/CallBack/CallBack";
import CallIndia from "../../AdminDashboard/TaxPreparation/CallIndia/CallIndia";
import PaymentTrying from "../../AdminDashboard/TaxPreparation/PaymentTrying/PaymentTrying";
import PaymentRecieved from "../../AdminDashboard/TaxPreparation/PaymentRecieved/PaymentRecieved";
import Extension from "../../AdminDashboard/TaxPreparation/Extension/Extension";
import Amendment from "../../AdminDashboard/TaxPreparation/Amendment/Amendment";
import Notice from "../../AdminDashboard/TaxPreparation/Notice/Notice";
import NoticeResolved from "../../AdminDashboard/TaxPreparation/NoticeResolved/NoticeResolved";
import ITINAdmin from "../../AdminDashboard/TaxPreparation/ITIN/ITIN";
import TaxPreparation from "../../AdminDashboard/TaxPreparation/TaxPreparation";
import NeverField from "../../AdminDashboard/TaxPreparation/NeverField/NeverField";
import AddTaxPrePending from "../../AdminDashboard/TaxPreparation/AddTaxPrePending/AddTaxPrePending";
import AddDocsReceived from "../../AdminDashboard/TaxPreparation/AddDocsReceived/AddDocsReceived";
const TaxPreparationRoutes = () => {
  return (
    <Route path="tax-preparation" element={<TaxPreparation />}>
      <Route path="assign-leads" element={<AssignLeads />} />
      <Route path="all" element={<All />} />
      <Route path="messages" element={<Messages />} />
      <Route path="new-file" element={<NewFile />} />
      <Route path="docs-pending" element={<DocsPending />} />
      <Route path="call-back" element={<CallBack />} />
      <Route path="call-india" element={<CallIndia />} />
      <Route path="never-field" element={<NeverField />} />
      <Route path="add-tax-pre-pending" element={<AddTaxPrePending />} />
      <Route path="add-docs-received" element={<AddDocsReceived />} />

      <Route path="payment-trying" element={<PaymentTrying />} />
      <Route path="payment-recieved" element={<PaymentRecieved />} />
      <Route path="extension" element={<Extension />} />
      <Route path="amendment" element={<Amendment />} />
      <Route path="notice" element={<Notice />} />
      <Route path="notice-resolved" element={<NoticeResolved />} />
      <Route path="itin" element={<ITINAdmin />} />
    </Route>
  );
};

export default TaxPreparationRoutes;
